module.exports = new __parcel__URL__("closed-zh-cn.1b728cf5.webp").toString();